import React from "react";
import PropTypes from "prop-types";

import mutationFactory, { smsInfo } from "model/gql/mutations";
import { cardsForClient } from "model/gql/queries";

const SmsMutation = mutationFactory(smsInfo);

function CardSmsSwitch(props) {
  return (
    <SmsMutation cardId={props.cardId} on={props.action === "on"}>
      {({ mutate }) => {
        return props.children({ mutate, query: cardsForClient.query });
      }}
    </SmsMutation>
  );
}

CardSmsSwitch.displayName = "CardSmsSwitch";

CardSmsSwitch.propTypes = {
  children: PropTypes.func.isRequired,
  cardId: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

CardSmsSwitch.defaultProps = {};

export default CardSmsSwitch;



// WEBPACK FOOTER //
// ./src/data-containers/CardSmsSwitch/CardSmsSwitch.js